var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"view pa-2 green"},[_c('v-layout',{staticClass:"view-content white",staticStyle:{"overflow":"hidden"}},[_c('v-layout',{staticClass:"relative",attrs:{"column":""}},[_c('transition',{attrs:{"name":_vm.transition}},[_c(_vm.currentView,{tag:"component",on:{"onChangeView":_vm.changeView}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }